<template>
    <el-dialog
        :title="type === 'practice' ? '练习结果' : $t('exam.result')"
        class="fiscan-result-dialog"
        :visible="value"
        width="600px"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        :show-close="false"
        :close-on-press-escape="false"
        @close="close"
    >
        <template v-if="value">
            <div class="container" v-if="type === 'practice'">
                <div class="result">
                    <img src="~@/assets/images/student/exam_pass.png" alt="pass">
                    <p class="status unpass">完成练习</p>
                </div>
                <div class="info-wrap">
                    <p class="info">
                        <span class="title">总题数：</span>
                        <span class="content">{{data.total}}</span>
                    </p>
                    <p class="info">
                        <span class="title">正确：</span>
                        <span class="content">{{data.correct}} 题</span>
                    </p>
                    <p class="info">
                        <span class="title">错误：</span>
                        <span class="content">{{data.wrong}} 题</span>
                    </p>
                    <p class="info">
                        <span class="title">正确率：</span>
                        <span class="content">{{ ((data.correct/data.total)*100).toFixed(1) }}%</span>
                    </p>
                    <p class="info">
                        <span class="title">用时：{{data.usedTime}}</span>
                        <span class="content"></span>
                    </p>
                    <p class="info other">
                        于 {{data.submitTime}} 提交作答
                    </p>

                    <div class="btn-wrap">
                        <el-button @click="afterCloseResult(true)" type="primary" size="medium">查看考卷</el-button>
                    </div>
                </div>
            </div>

            <div class="container" v-else>
                <p class="score">{{data.score}} {{$t('paper.points')}}</p>
                <div class="result">
                    <img v-if="data.isPass" src="~@/assets/images/student/exam_pass.png" alt="pass">
                    <img v-else src="~@/assets/images/student/exam_unpass.png" alt="not pass">
                    <p class="status" :class="data.isPass ? 'pass':'unpass' ">
                        {{data.isPass ? '恭喜你，通过考试！' : '很遗憾，你未通过考试！'}}
                    </p>
                </div>
                <div class="info-wrap">
                    <p class="info">
                        <span class="title">考试题目：</span>
                        <span class="content">{{data.paperName}}</span>
                    </p>
                    <p class="info">
                        <span class="title">总分：</span>
                        <span class="content">{{data.paperScore}} 分</span>
                    </p>
                    <p class="info">
                        <span class="title">及格分：</span>
                        <span class="content">{{data.passScore}} 分</span>
                    </p>
                    <p class="info">
                        <span class="title">正确：</span>
                        <span class="content">{{data.correct}} 题</span>
                    </p>
                    <p class="info">
                        <span class="title">错误：</span>
                        <span class="content">{{data.wrong}} 题</span>
                    </p>
                    <p class="info">
                        <span class="title">正确率：</span>
                        <span class="content">{{ ((data.correct/data.total)*100).toFixed(1) }}%</span>
                    </p>
                    <p class="info other">
                        于 {{data.submitTime}} 提交作答
                    </p>

                    <div class="btn-wrap">
                        <el-button @click="afterCloseResult(false)" v-if="data.allowReview === false" size="medium">返回</el-button>
                        <el-button @click="afterCloseResult(true)"  v-else type="primary" size="medium">查看考卷</el-button>
                    </div>
                </div>
            </div>
        </template>

    </el-dialog>
</template>

<script>
import dayjs from 'dayjs'

export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        id: {
            required: true,
        },
        type: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            data: {}
        }
    },

    watch: {
        value(val) {
            // 打开
            if (val) {
                this.initDialog();
            }
        },
    },

    methods: {
        initDialog() {
            if (this.type === 'practice') {
                this.$api.fiscanPracticeAchievement(this.id).then(res => {
                    this.data = res.package
                    const usedTime = dayjs(this.data.submitTime) - dayjs(this.data.startTime)
                    this.data.usedTime = `${dayjs(usedTime).minute()}分${dayjs(usedTime).second()}秒`
                })
            }

            if (this.type === 'exam') {
                this.$api.theoryExamAchievement(this.id).then(res => {
                    this.data = res.package
                })
            }

            if (this.type === 'mockExam') {
                this.$api.theoryMockExamAchievement(this.id).then(res => {
                    this.data = res.package
                })
            }
        },

        afterCloseResult(isReview) {
            this.close()
            this.$emit('close-result', isReview);
        },

        close() {
            this.$emit('input', false)
        }
    },
}
</script>

<style lang="scss">
.fiscan-result-dialog {

    .container {
        padding: 10px 30px;
    }

    .score {
        font-size: 28px;
        text-align: center;
        font-weight: 600;
        color: #019595;
    }

    .result {
        text-align: center;
        img {
            height: 120px;
        }
        .status {
            font-size: 15px;
            font-weight: 600;
            &.pass {
                color: $green;
            }
            &.unpass {
                color: $red;
            }
        }
    }

    .info-wrap {
        margin-top: 10px;
        padding: 0 30px;

        .info {
            padding: 7px 0;
        }

        .title {
            color: #333;
        }

        .content {
            color: #666;
        }

        .other {
            color: #999;
            font-size: 12px;
        }
    }

    .btn-wrap {
        padding-top: 10px;
        text-align: center;
    }
}
</style>
